import { getUserConfiguration } from 'owa-session-store';
import HelpId from '../data/HelpId';
import { format } from 'owa-strings';
import { select } from 'satcheljs/lib/legacy';

export interface GetHelpUrlState {
    helpUrlFormatString: string;
}

export default select<GetHelpUrlState>({
    helpUrlFormatString: () => getUserConfiguration().SessionSettings.HelpUrl,
})(function getHelpUrl(helpId: HelpId, state?: GetHelpUrlState): string {
    return format(state.helpUrlFormatString, helpId);
});
